//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["stock","nSegments"],"GetSegmentInformation",{R_:{segmentInformation:""}},1,0],[["segmentInformation","nReversedSegments"],"ReverseDirection",{R_:{reversedSegmentInformation:""}},1,0],[["segmentInformation"],"GetNumberOfBends",{R_:{nBends:''}},1,0],[["segmentInformation","totalLength","nBends"],"GenerateXyzReport",{R_:{bends:""}},1,0],[["segmentInformation","totalLength","nBends"],"GenerateYbcReport",{R_:{bends:""}},1,0],[["segmentInformation","totalLength","nBends"],"GenerateMil98Report",{R_:{bends:""}},1,0]],[]];
SPLM.Routing.BendReportManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.BendReportManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.BendReportManager.SegmentInformation = class{
    constructor(stock,segment,isStraight,length,startControlPoint,endControlPoint,bendCorner,bendRadius,bendPosition,startNormal,endNormal,startControlPointPosition,endControlPointPosition){
        this.stock=stock;this.segment=segment;this.isStraight=isStraight;this.length=length;this.startControlPoint=startControlPoint;this.endControlPoint=endControlPoint;this.bendCorner=bendCorner;this.bendRadius=bendRadius;this.bendPosition=bendPosition;this.startNormal=startNormal;this.endNormal=endNormal;this.startControlPointPosition=startControlPointPosition;this.endControlPointPosition=endControlPointPosition;}
    get Stock(){return this.stock}
    set Stock(val){this.stock = val}
    get Segment(){return this.segment}
    set Segment(val){this.segment = val}
    get Isstraight(){return this.isStraight}
    set Isstraight(val){this.isStraight = val}
    get Length(){return this.length}
    set Length(val){this.length = val}
    get Startcontrolpoint(){return this.startControlPoint}
    set Startcontrolpoint(val){this.startControlPoint = val}
    get Endcontrolpoint(){return this.endControlPoint}
    set Endcontrolpoint(val){this.endControlPoint = val}
    get Bendcorner(){return this.bendCorner}
    set Bendcorner(val){this.bendCorner = val}
    get Bendradius(){return this.bendRadius}
    set Bendradius(val){this.bendRadius = val}
    get Bendposition(){if(this.bendPosition === undefined) this.bendPosition = new SPLM.Point3d(); return this.bendPosition}
    set Bendposition(val){this.bendPosition = val}
    get Startnormal(){if(this.startNormal === undefined) this.startNormal = new SPLM.Vector3d(); return this.startNormal}
    set Startnormal(val){this.startNormal = val}
    get Endnormal(){if(this.endNormal === undefined) this.endNormal = new SPLM.Vector3d(); return this.endNormal}
    set Endnormal(val){this.endNormal = val}
    get Startcontrolpointposition(){if(this.startControlPointPosition === undefined) this.startControlPointPosition = new SPLM.Point3d(); return this.startControlPointPosition}
    set Startcontrolpointposition(val){this.startControlPointPosition = val}
    get Endcontrolpointposition(){if(this.endControlPointPosition === undefined) this.endControlPointPosition = new SPLM.Point3d(); return this.endControlPointPosition}
    set Endcontrolpointposition(val){this.endControlPointPosition = val}
};

SPLM.Routing.BendReportManager.XyzReport = class{
    constructor(xc,yc,zc,radius){
        this.xc=xc;this.yc=yc;this.zc=zc;this.radius=radius;}
    get Xc(){return this.xc}
    set Xc(val){this.xc = val}
    get Yc(){return this.yc}
    set Yc(val){this.yc = val}
    get Zc(){return this.zc}
    set Zc(val){this.zc = val}
    get Radius(){return this.radius}
    set Radius(val){this.radius = val}
};

SPLM.Routing.BendReportManager.YbcReport = class{
    constructor(y,b,c,radius){
        this.y=y;this.b=b;this.c=c;this.radius=radius;}
    get Y(){return this.y}
    set Y(val){this.y = val}
    get B(){return this.b}
    set B(val){this.b = val}
    get C(){return this.c}
    set C(val){this.c = val}
    get Radius(){return this.radius}
    set Radius(val){this.radius = val}
};

SPLM.Routing.BendReportManager.Mil98Report = class{
    constructor(c,f,e,g,y){
        this.c=c;this.f=f;this.e=e;this.g=g;this.y=y;}
    get C(){return this.c}
    set C(val){this.c = val}
    get F(){return this.f}
    set F(val){this.f = val}
    get E(){return this.e}
    set E(val){this.e = val}
    get G(){return this.g}
    set G(val){this.g = val}
    get Y(){return this.y}
    set Y(val){this.y = val}
};

export default SPLM;